import React, { useState } from "react";
import Loader from "components/Loader";
import { useUserContext } from "store/contexts/userContext";
import TeamService from "services/TeamService";
import TaskReactionDialogue from "./ReactionDailogue";
import * as moment from "moment";
import { useTeamContext } from "store/contexts/teamContext";
import userAvatar from "assets/img/user.svg";
import { CSSTransition } from "react-transition-group";
import { useTimelineContext } from "store/contexts/timelineContext";

var styles = {
  buzzUserImage: {
    minWidth: "29px",
    minHeight: "29px",
    maxWidth: "29px",
    maxHeight: "29px",
    borderRadius: "50%",
    overflow: "hidden",
    padding: "0",
    objectFit: "cover",
  },
  buzzUsersCount: {
    fontSize: "12px",
    fontWeight: "400",
  },
};

export default ({ listTask, openEngagement }) => {
  const classes = styles;
  const { team } = useTeamContext();
  const { user } = useUserContext();
  const { updateTask, setHide } = useTimelineContext();
  const [showReactions, setShowReaction] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dialogState, setDialogState] = useState(false);
  const moreReaction = {
    display: "flex",
    justifyContent: "center",
    color: "rgb(0 0 0 / 75%)",
    fontWeight: "400",
    padding: "5px 10px",
  };

  const showReactionUserList = async (event) => {
    setShowReaction(event.currentTarget);

    if (!listTask.reactions) {
      setLoading(true);

      await getReactionDetails();
    }
  };

  const getReactionDetails = async () => {
    try {
      const response = await TeamService.getBuzzlistsTodo(
        team.id,
        listTask.todo_list_id,
        listTask.id
      );

      updateTask({
        ...listTask,
        reactions: response?.data?.data,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const hideReactionUserList = () => {
    setShowReaction(null);
  };

  const showDailogue = () => {
    setShowReaction(null);
    setDialogState(true);
    setHide(true);
  };

  return (
    <>
      <div className="post-reactions">
        <div
          className="reaction-counter"
          onMouseEnter={showReactionUserList}
          onMouseLeave={hideReactionUserList}
          onClick={showDailogue}
        >
          {listTask?.buzzes_count > 0 && (
            <>
              <img
                src={
                  (listTask?.buzz_type_id === null
                    ? listTask?.recent_buzz_activity_user?.avatar
                    : user?.avatar) ?? userAvatar
                }
                alt={`${listTask?.recent_buzz_activity_user?.full_name}`}
                style={classes.buzzUserImage}
              />
              <span style={classes.buzzUsersCount}>
                {`
                ${
                  listTask?.buzz_type_id !== null
                    ? "You"
                    : listTask?.recent_buzz_activity_user?.full_name
                }
                ${
                  listTask?.buzzes_count > 1
                    ? ` & ${listTask?.buzzes_count - 1} other`
                    : ""
                }
                Reacted
              `}
              </span>
            </>
          )}
          {listTask?.expressions_count > 0 && (
            <>
              {!listTask?.buzzes_count && (
                <>
                  <img
                    src={
                      (!listTask?.user_expressed
                        ? listTask?.recent_expressed_activity_user?.avatar
                        : user?.avatar) ?? userAvatar
                    }
                    alt={`${listTask?.recent_expressed_activity_user?.full_name}`}
                    style={classes.buzzUserImage}
                  />
                  <span style={classes.buzzUsersCount}>
                    {`
                    ${
                      listTask?.user_expressed
                        ? "You"
                        : listTask?.recent_expressed_activity_user?.full_name
                    }
                    ${
                      listTask?.expressions_count > 1
                        ? ` & ${listTask?.expressions_count - 1} other`
                        : ""
                    }
                    Engaged
                  `}
                  </span>
                </>
              )}
              {!!listTask?.buzzes_count && (
                <>
                  <span
                    style={classes.buzzUsersCount}
                  >{` & ${listTask?.expressions_count} Engaged`}</span>
                </>
              )}
            </>
          )}
          <CSSTransition
            in={Boolean(showReactions)}
            timeout={300}
            unmountOnExit
            classNames="dropdown-element"
          >
            <div className="reactionListContent">
              <div className="reactionListContainer">
                {loading && <Loader width={40} height={40} />}
                <div>
                  {listTask?.reactions &&
                    listTask?.reactions?.slice(0, 5).map((response, index) => (
                      <ul key={index} className="displayReactionList">
                        <li key={response.id} className="displayReactionList">
                          <p className="muiListItem">
                            <span className="displayReactionName">
                              <span>
                                {response?.user?.id === user?.id
                                  ? "You Reacted At "
                                  : response?.user?.full_name}
                              </span>
                              <span className="displayDate">
                                {moment(response?.user?.responded_at).format(
                                  "MMM DD, YYYY"
                                )}
                              </span>
                            </span>
                          </p>
                        </li>
                      </ul>
                    ))}
                  {listTask?.buzzes_count > 5 && (
                    <div style={moreReaction}>
                      <span>and {listTask?.buzzes_count} more</span>
                    </div>
                  )}
                </div>
                {listTask.reactions &&
                  listTask.reactions.length === 0 &&
                  !loading && <div style={moreReaction}>No Reaction</div>}
              </div>
            </div>
          </CSSTransition>
        </div>
        <div className="post_stats">
          <span className="comments" onClick={openEngagement}>
            {listTask?.expressions_count} Engagements{" "}
          </span>
        </div>
      </div>
      {listTask?.reactions?.length !== 0 && !loading && (
        <TaskReactionDialogue
          loading={loading}
          listTask={listTask}
          dialogState={dialogState}
          setDialogState={setDialogState}
        />
      )}
    </>
  );
};
